import { render } from "./Opinion.vue?vue&type=template&id=40de0c1a&scoped=true"
import script from "./Opinion.vue?vue&type=script&lang=js"
export * from "./Opinion.vue?vue&type=script&lang=js"

import "./Opinion.vue?vue&type=style&index=0&id=40de0c1a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-40de0c1a"

export default script